import { render, staticRenderFns } from "./BOMListWrite.vue?vue&type=template&id=0a8b00f6&scoped=true"
import script from "./BOMListWrite.vue?vue&type=script&setup=true&lang=ts"
export * from "./BOMListWrite.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BOMListWrite.vue?vue&type=style&index=0&id=0a8b00f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.103.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8b00f6",
  null
  
)

export default component.exports